import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import queryString from 'query-string'
import MovieSearchForm from './MovieSearchForm'

class MovieSearchFormWithRouter extends Component {
    constructor(props) {
        super(props)

        this.state = {
            query: this.getSearchQueryString()
        }

        this.handleChange = this.handleChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
    }

    componentDidUpdate(prevProps) {
        if(prevProps.location.search !== this.props.location.search) {
            const searchQuery = this.getSearchQueryString()

            if(searchQuery !== this.state.query) {
                this.setState({query: searchQuery})
            }
        }
    }

    getQueryStringValues() {
        const { location } = this.props

        return queryString.parse(location.search)
    }

    getSearchQueryString() {
        const queryStringValues = this.getQueryStringValues()
        
        if(queryStringValues.search) {
            return queryStringValues.search
        } else {
            return ''
        }
    }

    setSearchQuery(query) {
        const { history } = this.props

        let queryStringValues = this.getQueryStringValues()

        if(query) {
            queryStringValues.search = query
        } else if(queryStringValues.search) {
            delete queryStringValues.search
        }

        history.push({
            search: queryString.stringify(queryStringValues)
        })
    }

    handleChange(e) {
        const query = e.target.value

        this.setState({query: query})

        if('' === query.trim()) {
            this.setSearchQuery(false)
        }
    }

    handleSubmit(e) {
        e.preventDefault();

        const query = this.state.query.trim()

        if(query !== this.getSearchQueryString()) {
            this.setSearchQuery(query)
        }

        if(this.props.onSubmitSearch) {
            this.props.onSubmitSearch()
        }
    }

    render() {
        const { translation } = this.props

        return <MovieSearchForm
            textClass={this.props.textClass}
            translation={translation}
            query={this.state.query}
            handleChange={this.handleChange}
            handleSubmit={this.handleSubmit}
        />
    }
}


export default withRouter(MovieSearchFormWithRouter)